// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"179":"ceb1f74b","380":"e18b2a67","520":"51732d9c","628":"e8c05f0a","654":"71b9f441","752":"f6a97f60","840":"eedfae6f","928":"2d2dab31"}[chunkId] + ".css";
};